import { PropsWithChildren } from 'react';

import { Gradients } from '@/shared/components/theme/gradient';
import { cn } from '@/shared/utils/cn';

export const ProjectDetailsHeader = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        'flex flex-col rounded-md border border-dashed border-white/15 p-6',
        `${Gradients.transparentWhiteGradient} bg-gradient-to-b backdrop-blur-xl`,
        className,
      )}
    >
      {children}
    </div>
  );
};

export const ProjectDetailsHeaderActions = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className={'flex w-full flex-row gap-2 xl:gap-6'}>{children}</div>
  );
};

export const ProjectDetailsHeaderLeadingAction = ({
  children,
}: PropsWithChildren) => {
  return <div className="flex-1">{children}</div>;
};

export const ProjectDetailsHeaderTrailingAction = ({
  children,
}: PropsWithChildren) => {
  return (
    <div className="flex flex-1 flex-col gap-4 md:flex-row">{children}</div>
  );
};
